import React from 'react';
import '../../styles/vc-message/main.css';

const Main = () => {
    return (
        <div id='vcmessageMain'>
            <section className="d-flex justify-content-center p-2 mt-4">
                <div className="container">
                    <div className="row d-flex justify-content-around align-items-start message-main-div">
                        <div className="right">
                            <img src="../../assets/images/vc-img.jpg" alt="chancellor" />
                            <h6>Prof. Sangeeta Shukla</h6>
                            <p>Vice-Chancellor</p>
                        </div>
                        <div className="left">
                            <h1>Message</h1>
                            <div className="content">
                                <p>
                                    India, the oldest civilisation and the oldest nation of the world,
                                    inherits a rich tradition of intellectual exploration. The Rigveda
                                    prayer :' आ नो भद्रा क्रतवो यन्तु विश्वतः' (Let the noble ideas come
                                    to us from the entire world.) underlines the openness in Indian
                                    thinking since ancient times. Even in the ancient period, India led
                                    the higher education system of the world, attracting student
                                    population from a number of countries to its famous seats of
                                    learning at Takshila and Nalanda.
                                </p>
                                <p>
                                    Established in 1965, the Chaudhary Charan Singh University, Meerut
                                    (formerly known as Meerut University, Meerut) has been continuously
                                    engaged in creation and dissemination of world class knowledge by
                                    involving all the stake-holders, i.e., students, teachers,
                                    supporting staff and the people from different walks of the society.
                                    Over the years, it has steadily evolved itself as one of the leading
                                    centers of comprehensive learning with its exposure to and linkages
                                    with the peers at national and international levels. With its state
                                    of the art infrastructure, well equipped laboratories and highly
                                    qualified and dedicated faculty, the University is committed to the
                                    task of harnessing and cultivating the capabilities of young
                                    students with a view to enabling them to carve suitable space for
                                    themselves in the modern economic world.
                                </p>
                                <p>
                                    Conscious of its social responsibility and accountability, the
                                    University since its inception has been striving hard to inculcate
                                    the right values among students so as to develop them as socially
                                    sensitive citizens.
                                </p>
                                <p>
                                    Sustainable development and inclusiveness being our main mottos, the
                                    university encourages teaching and research programmes addressing
                                    the issues of concern to the contemporary society. Thus, the system
                                    encourages not only the curricular activities, but also promotes
                                    co-currical, extracurricular and extension activities through its
                                    outreach to and interaction with the local community.
                                </p>
                                <p>
                                    While we have come a long way and our academic journey is marked by
                                    a number of path breaking milestones, we have to keep pace with the
                                    fast changing needs and expectations of the society. The process of
                                    creating new knowledge and producing capable human beings dedicated
                                    to the upliftment of the nation and the world has to continue with
                                    renewed vigour in an unabated manner.
                                </p>
                                <p>
                                    I extend my best wishes to all the students, teachers and members of
                                    the administrative staff who are part of the University and to those
                                    also who intend to join us in our endeavour to liberate the humanity
                                    with the help of the powerful tool of knowledge.
                                </p>
                                <p className="mt-5 text-end">
                                    <i>Prof. Sangeeta Shukla</i>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Main;